if (!customElements.get('dyld-dual-collection')) {
  customElements.define('dyld-dual-collection', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      if (this.tabs.length) {
        this.querySelector('nav').setAttribute('role', 'tablist');
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels.find(panel => panel.dataset.panel === tab.dataset.tab).id);
        });
        this.panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
        this.onClick = event => {
          const tab = event.target.closest('[data-tab]');
          if (!tab || !this.contains(tab)) return;
          event.preventDefault(); this.activate(tab.dataset.tab);
        };
        this.onKey = event => {
          const index = this.tabs.indexOf(event.target);
          if (index >= 0 && event.key === ' ') {
            event.preventDefault();
            this.activate(event.target.dataset.tab);
            return;
          }
          if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(this.tabs[next].dataset.tab); this.tabs[next].focus();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.activate(this.dataset.default === 'two' ? 'two' : 'one');
        this.setAttribute('data-enhanced', '');
      }
      if ('IntersectionObserver' in window) {
        this.sheenObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-sheen-visible', '');
            this.sheenObserver.unobserve(entry.target);
          });
        }, { threshold: 0.5 });
        this.querySelectorAll('.dyld-dual__entries').forEach(badge => this.sheenObserver.observe(badge));
      }
    }
    activate(key) {
      this.tabs.forEach(tab => { const active = tab.dataset.tab === key; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); this.sheenObserver?.disconnect(); }
  });
}
